import { render, staticRenderFns } from "./award.vue?vue&type=template&id=82143f7c&scoped=true"
import script from "./award.vue?vue&type=script&lang=js"
export * from "./award.vue?vue&type=script&lang=js"
import style0 from "./award.vue?vue&type=style&index=0&id=82143f7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82143f7c",
  null
  
)

export default component.exports